export const CHANNEL_WIDTH = 's80'

export const CHANNEL_ORDER = ['email', 'push'] as const
